import styled from 'styled-components';

export const Svg = styled.svg`
  width: 220px;
  margin-left: -10px;
  margin-top: -30px;
`


// WEBPACK FOOTER //
// ./src/components/Logo/styles.js